import { render } from "./HealthPackage.vue?vue&type=template&id=4ecfbf57"
import script from "./HealthPackage.vue?vue&type=script&lang=js"
export * from "./HealthPackage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__